import React__default, { memo, useContext } from 'react';
import styles from 'ui-components/Slider.scss';
import { SliderContext } from './context.js';

var Highlight = /*#__PURE__*/memo(function (_ref) {
  var _ref2;
  var start = _ref.start,
    end = _ref.end,
    minValue = _ref.minValue;
  var _useContext = useContext(SliderContext),
    orientation = _useContext.orientation,
    valueToPercent = _useContext.valueToPercent,
    reverse = _useContext.reverse;
  var length = end - start + minValue;
  var horizontal = orientation === "horizontal";
  var startPosition = reverse ? 100 - valueToPercent(length) : valueToPercent(start);
  var width = reverse ? 100 - startPosition : valueToPercent(length);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.value,
    style: (_ref2 = {}, _ref2[horizontal ? "left" : "bottom"] = startPosition + "%", _ref2[horizontal ? "width" : "height"] = width + "%", _ref2)
  });
});

export { Highlight };
//# sourceMappingURL=highlight.js.map
